import "react-datepicker/dist/react-datepicker.css";
import { useParams } from "react-router-dom";

import { useEffect, useState } from "react";

import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ProductOrderService from "../../services/ProductOrderService";
import DataTableTransaction from "../../ui/DataTableTransaction";
import SellingService from "../../services/SellingService";
import DataTableTransactionSell from "../../ui/DataTableTransactionSell";
import withLoader from './../../components/layouts/WithLoader';
import DataTableTransactionRestSell from "../../ui/DataTableTransactionRestSell";
const LivraisonDocumentToStock = ({ startLoading, stopLoading }) => {
  const [documentProducts, setDocumentProducts] = useState([]);
  const [document, setDocument] = useState(null);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [infoAlertText, setInfoAlertText] = useState();
  const [change, setChange] = useState(false);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    startLoading()

    if (sessionStorage.getItem("typeDocument") === "facture") {
      ProductOrderService.getProductTransactionHistoryByFacture(
        sessionStorage.getItem("DocumentId"),
        getCurrentUserId()
      )
        .then((response) => {
          console.log("getFactureByRef", response.data.success);
          setDocument(response.data.success[0]);
        })
        .catch(() => {
          alert("problème de connexion");
        }).finally(()=>{
          stopLoading()
        });
    }else if (sessionStorage.getItem("typeDocument") === "BDC") {
      ProductOrderService.getProductTransactionHistoryByBDC(
        sessionStorage.getItem("DocumentId"),
        getCurrentUserId()
      )
        .then((response) => {
          console.log("getFactureByRef", response.data.success);
          setDocument(response.data.success[0]);
        })
        .catch(() => {
          alert("problème de connexion");
        }).finally(()=>{
          stopLoading()
        });
    } else if (sessionStorage.getItem("typeDocument") === "po") {
      ProductOrderService.getProductTransactionHistoryByPO(
        sessionStorage.getItem("DocumentId"),
        getCurrentUserId()
      )
        .then((response) => {
          console.log("getFactureByRef", response.data.success);
          setDocument(response.data.success[0]);
        })
        .catch(() => {
          alert("problème de connexion");
        }).finally(()=>{
          stopLoading()
        });
    } else if (sessionStorage.getItem("typeDocument") === "BDCSell") {

     
      SellingService.getProductTransactionHistoryByBCSell(
        sessionStorage.getItem("DocumentId"),
        getCurrentUserId()
      )
        .then((response) => {
          console.log("getBCSellByRef", response.data.success[0].bonDeCommandeSale.ref);
          setDocument(response.data.success[0]);
          startLoading();
          SellingService.getSalesByRefCByRefBDC(
            response.data.success[0].bonDeCommandeSale.ref
            ,
            getCurrentUserId()
          )
            .then((response) => {
              console.log("response", response);
              if (Object.keys(response.data)[0] === "InvalidReference") {
                setOpenInfoAlert(true);
                setInfoAlertText("Info : la réference est invalide");
              } else if (Object.keys(response.data)[0] === "RelatedToFacture") {
                setOpenInfoAlert(true);
                setInfoAlertText("Info : cette achat est liée a une facture");
              } else if (Object.keys(response.data)[0] === "AlreadyCompleted") {
                setOpenInfoAlert(true);
                setInfoAlertText("Info :l'operation est terminé");
              } else if (Object.keys(response.data)[0] === "error") {
                setOpenErrorAlert(true);
                setErrorAlertText(
                  "Erreur : Aucun bon de commande de ce référence"
                );
              } else {
                setProducts( response.data.ProductsSales);
                
              }
            })
            .catch(() => {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur : il ya un probléme de connexion");
            })
            .finally(() => {
    
              stopLoading();
            });
        })
        .catch(() => {
          alert("problème de connexion");
        }).finally(()=>{
          stopLoading()
        });
    }
  }, [change]);

  function dataOfDocument() {
    if (sessionStorage.getItem("typeDocument") === "devis") {
      return (
        <div className="row">
          <div className="col-md-4 col-sm-6 col-12">
            <div className="info-box bg-gray ">
              <span className="info-box-icon">
                <i class="fas fa-dollar-sign"></i>{" "}
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Prix TTC</span>
                <span className="info-box-number">{document.ttPrice} DNT</span>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "70%" }} />
                </div>
                <span className="progress-description">
                  {document.htPrice} DNT prix HT
                </span>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 col-12">
            <div className="info-box bg-gray-dark ">
              <span className="info-box-icon">
                <i class="fas fa-chart-line"></i>{" "}
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Prix d'achat</span>
                <span className="info-box-number">
                  {documentProducts.buyingPrice} DNT
                </span>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "70%" }} />
                </div>
                {documentProducts.discountPercentage !== 0 && (
                  <span className="progress-description">
                    Promotion de{documentProducts.discountPercentage}%{" "}
                  </span>
                )}
                {documentProducts.discountPercentage === 0 && (
                  <span className="progress-description">
                    {documentProducts.htPrice} DNT prix HT
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 col-12">
            <div className="info-box  bg-black">
              <span className="info-box-icon">
                <i class="fas fa-shopping-cart"></i>
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Produits</span>

                {documentProducts.purchases && (
                  <span className="info-box-number">
                    {documentProducts.purchases.length}{" "}
                  </span>
                )}
                <div className="progress">
                  <div className="progress-bar" style={{ width: "100%" }} />
                </div>
                {documentProducts.purchases && (
                  <span className="progress-description">
                    {documentProducts.purchases.length}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    } else if (sessionStorage.getItem("typeDocument") === "bdc") {
      return (
        <div className="row">
          <div className="col-md-4 col-sm-6 col-12">
            <div className="info-box bg-gray ">
              <span className="info-box-icon">
                <i class="fas fa-dollar-sign"></i>{" "}
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Prix TTC</span>
                <span className="info-box-number">
                  {documentProducts.ttPrice} DNT
                </span>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "70%" }} />
                </div>
                <span className="progress-description">
                  {documentProducts.htPrice} DNT prix HT
                </span>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 col-12">
            <div className="info-box bg-gray-dark ">
              <span className="info-box-icon">
                <i class="fas fa-chart-line"></i>{" "}
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Prix d'achat</span>
                <span className="info-box-number">
                  {documentProducts.buyingPrice} DNT
                </span>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "70%" }} />
                </div>
                {documentProducts.discountPercentage !== 0 && (
                  <span className="progress-description">
                    Promotion de{documentProducts.discountPercentage}%{" "}
                  </span>
                )}
                {documentProducts.discountPercentage === 0 && (
                  <span className="progress-description">
                    {documentProducts.htPrice} DNT prix HT
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 col-12">
            <div className="info-box  bg-black">
              <span className="info-box-icon">
                <i class="fas fa-shopping-cart"></i>
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Produits</span>

                {documentProducts.purchases && (
                  <span className="info-box-number">
                    {documentProducts.purchases.length}{" "}
                  </span>
                )}
                <div className="progress">
                  <div className="progress-bar" style={{ width: "100%" }} />
                </div>
                {documentProducts.purchases && (
                  <span className="progress-description">
                    {documentProducts.purchases.length}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    } else if (sessionStorage.getItem("typeDocument") === "facture") {
      return (
        <div className="row">
          {console.log("document", document)}

          <div className="col-md-4 col-sm-6 col-12">
            <div className="info-box bg-gray ">
              <span className="info-box-icon">
                <i class="fas fa-dollar-sign"></i>{" "}
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Prix TTC</span>
                <span className="info-box-number">
                  {document["facture"].priceTT} DNT
                </span>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "70%" }} />
                </div>
                <span className="progress-description">
                  {document["facture"].buyinfPrice} DNT prix HT
                </span>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 col-12">
            <div className="info-box bg-gray-dark ">
              <span className="info-box-icon">
                <i class="fas fa-chart-line"></i>{" "}
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Prix d'achat</span>
                <span className="info-box-number">
                  {document["facture"].buyinfPrice} DNT
                </span>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "70%" }} />
                </div>
                {document["facture"].discountPercentage !== 0 && (
                  <span className="progress-description">
                    Promotion de{document["facture"].discountPercentage}%{" "}
                  </span>
                )}
                {document["facture"].discountPercentage === 0 && (
                  <span className="progress-description">
                    {document["facture"].buyinfPrice} DNT prix HT
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 col-12">
            <div className="info-box  bg-black">
              <span className="info-box-icon">
                <i class="fas fa-shopping-cart"></i>
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Produits</span>

                {document["facture"].purchases && (
                  <span className="info-box-number">
                    {document["facture"].purchases.length}{" "}
                  </span>
                )}
                <div className="progress">
                  <div className="progress-bar" style={{ width: "100%" }} />
                </div>
                {document["facture"].purchases && (
                  <span className="progress-description">
                    {document["facture"].purchases.length}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    } else if (sessionStorage.getItem("typeDocument") === "po") {
      return (
        <div className="row">
          {console.log("document", document)}

          <div className="col-md-4 col-sm-6 col-12">
            <div className="info-box bg-gray ">
              <span className="info-box-icon">
                <i class="fas fa-dollar-sign"></i>{" "}
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Prix TTC</span>
                <span className="info-box-number">
                  {document["purchaseOrder"].priceTT} DNT
                </span>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "70%" }} />
                </div>
                <span className="progress-description">
                  {document["purchaseOrder"].buyinfPrice} DNT prix HT
                </span>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 col-12">
            <div className="info-box bg-gray-dark ">
              <span className="info-box-icon">
                <i class="fas fa-chart-line"></i>{" "}
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Prix d'achat</span>
                <span className="info-box-number">
                  {document["purchaseOrder"].buyinfPrice} DNT
                </span>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "70%" }} />
                </div>
                {document["purchaseOrder"].discountPercentage !== 0 && (
                  <span className="progress-description">
                    Promotion de{document["purchaseOrder"].discountPercentage}%{" "}
                  </span>
                )}
                {document["purchaseOrder"].discountPercentage === 0 && (
                  <span className="progress-description">
                    {document["purchaseOrder"].buyinfPrice} DNT prix HT
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-4 col-sm-6 col-12">
            <div className="info-box  bg-black">
              <span className="info-box-icon">
                <i class="fas fa-shopping-cart"></i>
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Produits</span>

                {document["purchaseOrder"].productPurchases && (
                  <span className="info-box-number">
                    {document["purchaseOrder"].productPurchases.length}{" "}
                  </span>
                )}
                <div className="progress">
                  <div className="progress-bar" style={{ width: "100%" }} />
                </div>
                {document["purchaseOrder"].productPurchases && (
                  <span className="progress-description">
                    {document["purchaseOrder"].productPurchases.length}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    } else if (sessionStorage.getItem("typeDocument") === "BDCSell") {
      return (
        <div className="row">
          {console.log("document", document)}
          <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-user"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Client</span>
                      <span className="info-box-number">
                        {document["bonDeCommandeSale"]?.client.title}
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>

                    </div>
                  </div>
                </div>
          <div className="col-md-3 col-sm-6 col-12">
            <div className="info-box bg-gray ">
              <span className="info-box-icon">
                <i class="fas fa-dollar-sign"></i>{" "}
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Prix TTC</span>
                <span className="info-box-number">
                  {document["bonDeCommandeSale"].priceTT} DNT
                </span>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "70%" }} />
                </div>
                <span className="progress-description">
                  {document["bonDeCommandeSale"].sellingPrice} DNT prix HT
                </span>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 col-12">
            <div className="info-box bg-gray-dark ">
              <span className="info-box-icon">
                <i class="fas fa-chart-line"></i>{" "}
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Prix de vente</span>
                <span className="info-box-number">
                  {document["bonDeCommandeSale"].sellingPrice} DNT
                </span>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "70%" }} />
                </div>
                {document["bonDeCommandeSale"].discountPercentage !== 0 && (
                  <span className="progress-description">
                    Promotion de
                    {document["bonDeCommandeSale"].discountPercentage}%{" "}
                  </span>
                )}
                {document["bonDeCommandeSale"].discountPercentage === 0 && (
                  <span className="progress-description">
                    {document["bonDeCommandeSale"].sellingPrice} DNT prix HT
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 col-12">
            <div className="info-box  bg-black">
              <span className="info-box-icon">
                <i class="fas fa-shopping-cart"></i>
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Produits</span>

                {document["bonDeCommandeSale"].sales && (
                  <span className="info-box-number">
                    {document["bonDeCommandeSale"].sales.length}{" "}
                  </span>
                )}
                <div className="progress">
                  <div className="progress-bar" style={{ width: "100%" }} />
                </div>
                {document["bonDeCommandeSale"].sales && (
                  <span className="progress-description">
                    {document["bonDeCommandeSale"].sales.length}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
  function tableProductOfDocument() {
    if (sessionStorage.getItem("typeDocument") === "facture") {
      return (
        <DataTableTransaction
          state={document["facture"].state}
          refFacture={document["facture"].ref}
          listProduits={document["transactionOperations"]}
        />
      );
    }else if (sessionStorage.getItem("typeDocument") === "BDC") {
      return (
        <DataTableTransaction
          state={document["bdc"].stateLivraison}
          refFacture={document["bdc"].ref}
          listProduits={document["transactionOperations"]}
        />
      );
    } else if (sessionStorage.getItem("typeDocument") === "po") {
      return (
        <DataTableTransaction
          state={document["productionOrder"].state}
          refFacture={document["productionOrder"].ref}
          listProduits={document["transactionOperations"]}
        />
      );
    } else if (sessionStorage.getItem("typeDocument") === "BDCSell") {
      return (
        <DataTableTransactionSell
          state={document["bonDeCommandeSale"].stateLivraison}
          refFacture={document["bonDeCommandeSale"].ref}
          listProduits={document["transactionOperations"]}
          bonSortir={true}
          change={change}
          setChange={setChange}
         

        />
      );
    }
  }



  function tableProductRestOfDocument() {
    if (sessionStorage.getItem("typeDocument") === "BDCSell") {
      return (
        <DataTableTransactionRestSell
          
          listProduits={products}
        />
      );
    }
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          {document && dataOfDocument()}
          {document && tableProductOfDocument()}
          {products && tableProductRestOfDocument()}
        </div>
      </section>
    </div>
  );
};
export default withLoader(LivraisonDocumentToStock);
